import { useEffect, useState } from "react";
import {
    Select,
    MenuItem,
    Typography,
    TextField,
    List,
    ListItem,
} from "@mui/material";
import { styled } from "@mui/system";
import ModalCard, {
    ModalRow,
    ModalTitle,
} from "../../components/modal/ModalCard";
import IGarbageCan from "../../models/garbage can/garbageCan";
import IFloor from "../../models/floor";
import ILocal from "../../models/local";
import FloorService from "../../services/floor/FloorService";
import Auth from "../../services/auth/AuthService";
import LocalService from "../../services/local/LocalService";
import {
    EGarbageCanType,
    EGarbageCanTypeKeysType,
} from "../../models/garbage can/garbageCanType";
import IBuilding from "../../models/building";
import BuildingService from "../../services/building/BuildingService";
import { useTranslation } from "react-i18next";

const Container = styled("div")({
    marginTop: 10,
    height: 350,
    overflow: "auto",
    padding: 10,
});
interface SummaryStepProps {
    macAddress: string;
    nGarbagesCan: number;
    garbageCans: IGarbageCan[];
    selectedBuilding: string;
    setSelectedBuilding: Function;
    selectedRoom: string;
    setSelectedRoom: Function;
    selectedFloor: string;
    setSelectedFloor: Function;
}

const SummaryStep = ({
    macAddress,
    nGarbagesCan,
    garbageCans,
    selectedBuilding,
    setSelectedBuilding,
    selectedRoom,
    setSelectedRoom,
    selectedFloor,
    setSelectedFloor,
}: SummaryStepProps) => {
    const [floors, setFloors] = useState<IFloor[]>([]);
    const [locals, setLocals] = useState<ILocal[]>([]);
    const [buildings, setBuildings] = useState<IBuilding[]>([]);
    const { t } = useTranslation(["sensor"]);
    useEffect(() => {
        FloorService.GetFloors(Auth.user?.buildingId || 0).then(setFloors);
        LocalService.GetLocalsByBuilding(Auth.user?.buildingId || 0).then(setLocals);
        BuildingService.GetBuildingsByTenant(Auth.user?.tenantId || 0).then(
            setBuildings
        );
    }, []);
    return (
        <Container>
            <ModalCard.Main isDivider={false}>
                <ModalRow sx={{ textAlign: "left" }}>
                    <ModalTitle>{t("sensor:sensor.macAddress")}</ModalTitle>
                    <TextField
                        sx={{ width: "70%", marginLeft: 5 }}
                        value={macAddress}
                        margin="normal"
                        variant="outlined"
                    />
                </ModalRow>

                <ModalRow sx={{ textAlign: "left" }}>
                    <ModalTitle>{t("common:header.building")}</ModalTitle>
                    <Select
                        name="building"
                        sx={{ width: "70%", marginLeft: 5 }}
                        size="small"
                        value={selectedBuilding}
                        onChange={(e) => setSelectedBuilding(e.target.value)}
                        defaultValue=""
                    >
                        {buildings.map((building) => (
                            <MenuItem key={building.id} value={building.id}>
                                {building.name}
                            </MenuItem>
                        ))}
                    </Select>
                </ModalRow>
                <ModalRow sx={{ textAlign: "left" }}>
                    <ModalTitle>{t("common:header.room")}</ModalTitle>
                    <Select
                        name="room"
                        sx={{ width: "70%", marginLeft: 5 }}
                        size="small"
                        value={selectedRoom}
                        onChange={(e) => setSelectedRoom(e.target.value)}
                        defaultValue=""
                    >
                        {locals.map((local) => (
                            <MenuItem key={local.id} value={local.id}>
                                {local.name}
                            </MenuItem>
                        ))}
                    </Select>
                </ModalRow>
                <ModalRow sx={{ textAlign: "left" }}>
                    <ModalTitle>{t("common:header.floor")}</ModalTitle>
                    <Select
                        name="floor"
                        sx={{ width: "70%", marginLeft: 5 }}
                        size="small"
                        value={selectedFloor}
                        onChange={(e) => setSelectedFloor(e.target.value)}
                        defaultValue=""
                    >
                        {floors.map((floor) => (
                            <MenuItem key={floor.id} value={floor.id}>
                                {floor.name}
                            </MenuItem>
                        ))}
                    </Select>
                </ModalRow>
                <Typography variant="body1">
                    {t("sensor:garbageCan.GarbageCanDetails")}
                </Typography>
                <ListItem
                    style={{
                        listStyle: "none",
                        padding: 0,
                        display: "flex",
                        flexDirection: "row",
                    }}
                >
                    {garbageCans
                        .slice(0, nGarbagesCan)
                        .map((garbage, index) => (
                            <List
                                key={index}
                                style={{
                                    marginRight: "7%",
                                    textAlign: "left",
                                }}
                            >
                                <Typography>
                                    {t("sensor:sensor.type")}:
                                    {t(
                                        `sensor:waste.${EGarbageCanType[
                                        garbage.type
                                        ] as EGarbageCanTypeKeysType
                                        }`
                                    )}
                                </Typography>
                                <Typography>
                                    {t("sensor:garbageCan.height")}:
                                    {garbage.height} cm
                                </Typography>
                                <Typography>
                                    {t("sensor:garbageCan.width")}:
                                    {garbage.width} cm
                                </Typography>
                                <Typography>
                                    {t("sensor:garbageCan.length")}:
                                    {garbage.length} cm
                                </Typography>
                            </List>
                        ))}
                </ListItem>
            </ModalCard.Main>
        </Container>
    );
};
export default SummaryStep;
